import BASE_RULE from '../baseRule';
import {SearchTypeAI} from './constants';
import {AIRule} from './types';

export const aiRuleDefaults: AIRule = {
	...BASE_RULE,
	elementType: SearchTypeAI,
	elementSubType1: 0,
};

export default aiRuleDefaults;
